/**
 * Rimozione degli articoli nascosti dal carrello.
 *
 * Gli ID arrivano da window.theme.hiddenCartIds, generato dallo snippet Liquid
 * 'cart-hidden-ids' (es. il prodotto contrassegno). Nasconderli a video non basta:
 * finché restano nel carrello pesano su subtotale, totale e ordine a checkout.
 * Qui li togliamo davvero, con una sola chiamata a /cart/update.js.
 *
 * Il filtro Liquid in 'cart-list' resta come rete di sicurezza: la rimozione è
 * asincrona, e senza di quello la riga lampeggerebbe a ogni page load prima di
 * sparire (o resterebbe a video se la chiamata fallisse).
 *
 * Quando gira: al load, al ritorno dalla bfcache (tipico rientro dal checkout con
 * il tasto indietro) e a ogni evento carrello, così un articolo aggiunto da terze
 * parti mentre l'utente naviga viene tolto subito.
 */
(function () {
	'use strict';

	var CART_UPDATED = 'mc:cart:updated';

	function getHiddenIds() {
		var ids = window.theme && window.theme.hiddenCartIds;
		return Array.isArray(ids) ? ids.map(String).filter(Boolean) : [];
	}

	function rootPath() {
		// Mercati localizzati: le route vivono sotto /it, /fr, ecc.
		var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
		return root || '/';
	}

	function isHidden(item, hiddenIds) {
		// /cart.js espone product_id, variant_id e id (= variante): li copriamo tutti,
		// così l'elenco funziona sia con ID prodotto sia con ID variante.
		return hiddenIds.indexOf(String(item.product_id)) !== -1 ||
			hiddenIds.indexOf(String(item.variant_id)) !== -1 ||
			hiddenIds.indexOf(String(item.id)) !== -1;
	}

	var running = false;

	function purge() {
		var hiddenIds = getHiddenIds();
		if (!hiddenIds.length || running) return Promise.resolve(false);

		running = true;

		// no-store: senza questo il carrello può arrivare dalla cache HTTP del
		// browser, cioè lo stato precedente all'ultima modifica.
		return fetch(rootPath() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
			.then(function (res) { return res.ok ? res.json() : null; })
			.then(function (cart) {
				if (!cart || !Array.isArray(cart.items)) return false;

				var updates = {};
				var found = false;
				cart.items.forEach(function (item) {
					if (isHidden(item, hiddenIds)) {
						updates[item.key] = 0;
						found = true;
					}
				});
				if (!found) return false;

				return fetch(rootPath() + 'cart/update.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify({ updates: updates })
				})
					.then(function (res) { return res.ok ? res.json() : null; })
					.then(function (updatedCart) {
						if (!updatedCart) return false;

						// Stesso evento che pubblica McShopify dopo una mutazione: fa
						// aggiornare pagina carrello, drawer e badge con i totali nuovi.
						window.dispatchEvent(new CustomEvent(CART_UPDATED, { detail: updatedCart }));
						if (window.globalUtils && typeof window.globalUtils.refreshHeaderCartCount === 'function') {
							window.globalUtils.refreshHeaderCartCount();
						}
						return true;
					});
			})
			.catch(function (err) {
				// Mai bloccare la pagina per questo: al peggio la riga resta nascosta
				// dal Liquid e riproveremo al prossimo evento carrello.
				if (typeof LOG === 'function') LOG('cartHiddenCleanup:', err);
				return false;
			})
			.finally(function () {
				running = false;
			});
	}

	window.globalUtils = window.globalUtils || {};
	window.globalUtils.purgeHiddenCartItems = purge;

	// Nell'editor del tema le sezioni si ri-renderizzano di continuo: non mettiamo
	// mano al carrello del merchant mentre configura (a video resta comunque nascosto).
	if (window.Shopify && window.Shopify.designMode) return;

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { purge(); });
	} else {
		purge();
	}

	// Ritorno dal checkout col tasto indietro: la pagina viene ripresa dalla bfcache
	// senza rieseguire gli script, ma il carrello nel frattempo può essere cambiato.
	window.addEventListener('pageshow', function (event) {
		if (event.persisted) purge();
	});

	// Carrello modificato da chiunque (anche da noi): la seconda passata trova il
	// carrello già pulito e si ferma dopo la sola lettura, quindi niente loop.
	[CART_UPDATED, 'mc:cart:added'].forEach(function (name) {
		window.addEventListener(name, function () { purge(); });
	});
})();
